import styled from "@emotion/styled";
import { Button } from "@mui/material";
import { getTripDrawerWidth } from "./TripDrawer";
import { ZIndexLevels } from "../risk/geoUtils";
import { RiskViewerKind } from "../../features/riskViewer/riskViewerSlice";


export const doNotForwardIsTripExpandedOrMobileOrRiskViewerStateKind = ( prop: string ) => prop !== "isTripExpanded" && prop !== "isMobile" && prop !== "riskViewerStateKind";

/**
 * Styled button for expanding or collapsing the trip drawer.
 */
export const StyledTripDrawerToggleButton = styled( Button, { shouldForwardProp: doNotForwardIsTripExpandedOrMobileOrRiskViewerStateKind } )<{ isTripExpanded: boolean, isMobile: boolean, riskViewerStateKind: string }>( ( { isTripExpanded, isMobile, riskViewerStateKind } ) => ( {
    position: "absolute",
    top: "0px",
    width: "25px",
    minWidth: "30px",
    height: riskViewerStateKind === RiskViewerKind.TRIP_STATE ? "180px" : "170px",
    marginTop: "10%",
    display: "inline-block",
    borderTopLeftRadius: "0",
    borderBottomLeftRadius: "0",
    borderTopRightRadius: "5px",
    borderBottomRightRadius: "5px",
    left: isTripExpanded && !isMobile ? getTripDrawerWidth( false ) : undefined,
    float: isTripExpanded && isMobile ? "right" : undefined,
    backgroundColor: "white",
    zIndex: ZIndexLevels.TopUIElement,
    border: isMobile ? "1px solid black" : "",
    borderLeft: "none",
    transition: "left 0.3s ease, float 0.3s ease",
} ) );


/**
 * Styled container for the drawer.
 */
export const DrawerContainer = styled( "div" )<{ backgroundColor: string }>( ( { backgroundColor } )=>( {
    height: "100vh",
    padding: 8,
    backgroundColor: backgroundColor
} ) );
